const g = (function f() {
  const instance = {
    isMobile: window.innerWidth <= 768,
    vh: window.innerHeight / 100,
    width: document.documentElement.clientWidth
  }

  const setProperties = () => {
    document.documentElement.style.setProperty('--vh', `${instance.vh}px`);
  }

  const update = () => {
    if (instance.isMobile !== window.innerWidth <= 768) {
      instance.isMobile = window.innerWidth <= 768;
      document.documentElement.dispatchEvent(new CustomEvent('changeDevice', {
        detail: { isMobile: instance.isMobile }
      }));
    }

    if (
      !instance.isMobile ||
      Math.abs(instance.vh*100 - window.innerHeight) > 80
      || Math.abs(instance.width - document.documentElement.clientWidth) > 0
    ) {
      document.documentElement.dispatchEvent(new CustomEvent('bigHeightResize'));
    }
    instance.vh = window.innerHeight / 100;
    instance.width = document.documentElement.clientWidth;

    setProperties();
  }

  setProperties();
  
  window.addEventListener('resize', update);

  return instance;
})();

export default g;